import { owcTheme } from '@one/design-tokens/js/regular/navify/light';
import styled from 'styled-components';

// Zero-height and sticky, so it stays at the top of whichever area scrolls without moving content.
export const PullToRefreshIndicatorLayout = styled.div`
  position: sticky;
  top: 0;
  z-index: 1;
  justify-self: stretch;
  width: 100%;
  height: 0;
  overflow: visible;
`;

export const PullToRefreshBubble = styled.div.attrs<{ $offset: number }>(({ $offset }) => ({
  style: { transform: `translate(-50%, ${$offset}px)` },
}))`
  position: absolute;
  top: 0;
  left: 50%;

  display: flex;
  align-items: center;
  gap: ${owcTheme['one-spacing-base-2']};
  padding: ${owcTheme['one-spacing-base-2']} ${owcTheme['one-spacing-base-4']};
  width: max-content;
  max-width: calc(100% - ${owcTheme['one-spacing-base-8']});

  border-radius: ${owcTheme['one-spacing-base-6']};
  background-color: ${owcTheme['one-color-background-base']};
  box-shadow: var(--one-elevation-box-shadow-2);
  pointer-events: none;
`;

export const PullToRefreshIcon = styled.span.attrs<{ $rotation: number }>(({ $rotation }) => ({
  style: { transform: `rotate(${$rotation}deg)` },
}))`
  display: flex;
`;
